/**
 * Route configuration organized by feature
 */
export const routes = {
  // Auth routes
  auth: {
    login: "/login",
  },

  // Dashboard routes
  dashboard: {
    home: "/dashboard",
  },

  // Doctor management routes
  doctors: {
    list: "/doctors",
    add: "/add-doctor",
  },

  // Patient management routes
  patients: {
    list: "/patients",
    add: "/add-patient",
    details: (id: string) => `/patient-details/${id}`,
  },

  // Medication management routes
  medications: {
    list: "/medications",
    add: "/add-medication",
    details: (id: string) => `/medication-details/${id}`,
  },

  // Medical resources routes
  medical: {
    drugsAndDiseases: "/drugs-and-diseases",
    drugsAndDiseasesDetails: (id: string, tabId: string) =>
      `/${tabId}/info/${id}`,
    congresses: "/medical-updates",
    calculators: "/medical-calculators",
    tab: (id: string) => `/tabs/${id}`,
    newsDetails: (tabId: string, newsId: string) =>
      `/${tabId}/details/${newsId}`,
    laboratoryValues: "/laboratory-values",
  },

  // Medora360 MD
  Medora360MD: {
    list: "/Medora360-md",
    clinicalCase: (id: string) => `/${id}/clinical-case`,
  },

  // QA routes
  qa: {
    home: "/qa",
    thread: (threadId: string) => `/qa/${threadId}`,
  },

  // Billing routes
  billing: {
    invoices: "/billing/invoices",
    claims: "/billing/claims",
    codes: "/billing/codes",
    newInvoice: "/billing/invoices/new",
    viewInvoice: (id: string) => `/billing/invoices/${id}`,
    editInvoice: (id: string) => `/billing/invoices/${id}/edit`,
    newClaim: "/billing/claims/new",
  },

  // Pharmacy management routes
  pharmacy: {
    inventory: "/pharmacy/inventory",
    approveRequests: "/pharmacy/approve-requests",
    suppliers: "/pharmacy/suppliers",
  },

  // Settings routes
  settings: {
    currencies: "/settings/currencies",
    insurers: "/settings/insurers",
  },
} as const;

/**
 * Legacy screens object for backward compatibility
 * @deprecated Use routes object instead
 */
export const screens = {
  dashboard: routes.dashboard.home,
  login: routes.auth.login,
  doctors: routes.doctors.list,
  addDoctor: routes.doctors.add,
  patients: routes.patients.list,
  addPatient: routes.patients.add,
  patientDetails: routes.patients.details(":id"),
  medications: routes.medications.list,
  addMedication: routes.medications.add,
  medicationDetails: routes.medications.details(":id"),
  drugsAndDiseases: routes.medical.drugsAndDiseases,
  congresses: routes.medical.congresses,
  medicalCalculators: routes.medical.calculators,
  qa: routes.qa.home,
};
